(function () {
    'use strict';
    angular
        .module('app')
        .constant('IServerRoutes', {
        git: '/api/git/'
    });
})();
